/**
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Get product info
export const PRODUCT_GET_REQUESTED = "PRODUCT_GET_REQUESTED";
export const PRODUCT_GET_SUCCESS = "PRODUCT_GET_SUCCESS";
export const PRODUCT_GET_ERROR = "PRODUCT_GET_ERROR";

//Get product list under a category
export const PRODUCT_LIST_GET_REQUESTED = "PRODUCT_LIST_GET_REQUESTED";
export const PRODUCT_LIST_GET_SUCCESS = "PRODUCT_LIST_GET_SUCCESS";
export const PRODUCT_LIST_GET_ERROR = "PRODUCT_LIST_GET_ERROR";

//Reset product list under a category
export const PRODUCT_LIST_RESET_REQUESTED = "PRODUCT_LIST_RESET_REQUESTED";
export const PRODUCT_LIST_RESET_SUCCESS = "PRODUCT_LIST_RESET_SUCCESS";
export const PRODUCT_LIST_RESET_ERROR = "PRODUCT_LIST_RESET_ERROR";

//Get product list for PDP
export const PRODUCT_LIST_FOR_PDP_GET_REQUESTED = "PRODUCT_LIST_FOR_PDP_GET_REQUESTED";
export const PRODUCT_LIST_FOR_PDP_GET_SUCCESS = "PRODUCT_LIST_FOR_PDP_GET_SUCCESS";
export const PRODUCT_LIST_FOR_PDP_GET_ERROR = "PRODUCT_LIST_FOR_PDP_GET_ERROR";
export const PRODUCT_LIST_DEETS = "PRODUCTS_DEETS";
export const PRODUCT_LIST_DEETS_S = "PRODUCTS_DEETS_S";
export const PRODUCT_LIST_DEETS_F = "PRODUCTS_DEETS_F";

// breadcrumbs
export const RESET_BREADCRUMBS = "RESET_BREADCRUMBS";
export const FETCH_BREADCRUMBS = "FETCH_BREADCRUMBS";
export const SET_BREADCRUMBS = "SET_BREADCRUMBS";

export const PRODCUT_LIST_FETCHING = "PRODCUT_LIST_FETCHING";
